import * as React from 'react'

import formatPrice from '../../../../common/utils/formatPrice'
import FeatureContainer from '../../../containers/feature'

import * as styles from './lockupPrice.module.css'

const LockupPrice = ({
  priceInCents,
  originalPriceInCents,
  discountPercentRounded,
  discountCents
}: {
  priceInCents: number
  originalPriceInCents?: number
  discountPercentRounded?: number
  discountCents?: number
}) => {
  if (originalPriceInCents) {
    return (
      <div className={styles.rootWithDiscount}>
        <FeatureContainer name="showWasNowPricing">
          <span className={styles.originalPrice}>
            ${formatPrice(originalPriceInCents)}
          </span>
          <span className={styles.promoPrice}>
            ${formatPrice(priceInCents)}
          </span>
        </FeatureContainer>
        <FeatureContainer name="!showWasNowPricing">
          <div>${formatPrice(priceInCents)}</div>
        </FeatureContainer>
        <FeatureContainer name="showSavingsPercentage">
          {discountPercentRounded && (
            <div className={styles.discountValue}>
              Save {discountPercentRounded}%
            </div>
          )}
        </FeatureContainer>
        <FeatureContainer name="showSavingsAmount">
          {discountCents && (
            <div className={styles.discountValue}>
              Save ${formatPrice(discountCents)}
            </div>
          )}
        </FeatureContainer>
      </div>
    )
  } else {
    return <div className={styles.root}>${formatPrice(priceInCents)}</div>
  }
}

export default LockupPrice
